import { inject } from '@angular/core';
import {
  CanActivateFn,
  GuardResult,
  MaybeAsync,
  Router,
} from '@angular/router';
import { AuthService } from '@infra-adapters/services/auth.service';

export const AuthGuard: CanActivateFn = (
  route,
  state
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isAuth().then((isAuth) => {
    if (isAuth) {
      return true;
    } else {
      return router.createUrlTree(['/onboarding']);
    }
  })
};
